"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class DictionaryItemsStore {
    constructor(dictionariesMap) {
        this._dictionariesMap = dictionariesMap;
        this._dictionariesItemsMap = new Map();
    }
    fetchItems(aggregatedSelection) {
        return __awaiter(this, void 0, void 0, function* () {
            const itemsPromises = Object.keys(aggregatedSelection).map((key) => __awaiter(this, void 0, void 0, function* () {
                const dictionary = this._dictionariesMap.get(key);
                if (!dictionary) {
                    throw new Error(`Dictionary ${key} not found`);
                }
                const dictionaryItems = yield dictionary.getByIds(aggregatedSelection[key]);
                return { id: key, dictionaryItems };
            }));
            const items = yield Promise.all(itemsPromises);
            items.forEach((item) => {
                this._dictionariesItemsMap.set(item.id, new Map(item.dictionaryItems.map((item) => [item.id, item])));
            });
        });
    }
    getItem(dictionaryId, itemId) {
        const dictionaryItems = this._dictionariesItemsMap.get(dictionaryId);
        if (!dictionaryItems) {
            throw new Error(`Dictionary ${dictionaryId} items not loaded`);
        }
        return dictionaryItems.get(itemId);
    }
    getAttributeName(attr, lcid) {
        const [dimensionId, hierarchyId, ...rest] = attr.split(".");
        if (rest.length === 0) {
            throw new Error(`Attribute name expected in path ${attr}`);
        }
        const dictionaryId = `${dimensionId}.${hierarchyId}`;
        const dictionary = this._dictionariesMap.get(dictionaryId);
        const definition = dictionary === null || dictionary === void 0 ? void 0 : dictionary.definition;
        if (!definition) {
            throw new Error(`Dictionary ${dictionaryId} not found`);
        }
        const attrId = rest[0];
        const attrItem = definition.attributes[attrId];
        if (!attrItem) {
            throw new Error(`${attr} not found`);
        }
        if (rest.length === 1) {
            const name = attrItem.names[lcid];
            if (!name) {
                throw new Error(`No attribute ${attr} name for locale ${lcid}`);
            }
            return name;
        }
        if (!attrItem.isReference) {
            throw new Error(`${attr} is not reference attribute`);
        }
        const refDictionary = attrItem.referencedDictionaryId;
        if (!refDictionary) {
            throw new Error(`No reference dictionary specified for ${attr} attribute`);
        }
        const refDictionaryAttribute = [refDictionary, ...rest.slice(1)].join(".");
        return this.getAttributeName(refDictionaryAttribute, lcid);
    }
    getAttributeValue(path, itemId, lcid) {
        const [dimensionId, hierarchyId, ...rest] = path.split(".");
        const attributeId = rest[0];
        if (rest.length === 0) {
            throw new Error(`Attribute name expected in path ${path}`);
        }
        const dictionaryId = `${dimensionId}.${hierarchyId}`;
        const dictionary = this._dictionariesMap.get(dictionaryId);
        const definition = dictionary === null || dictionary === void 0 ? void 0 : dictionary.definition;
        if (!definition) {
            throw new Error(`Dictionary ${dictionaryId} not found`);
        }
        const attrId = rest[0];
        const attrItem = definition.attributes[attrId];
        if (!attrItem) {
            throw new Error(`${path} not found`);
        }
        if (rest.length === 1) {
            const item = this.getItem(dictionaryId, itemId);
            if (!item) {
                throw new Error(`Item ${itemId} of ${dictionaryId} not found`);
            }
            if (attrItem.isLocalized) {
                return item.getLocalizedValue(attributeId, lcid);
            }
            return item.getValue(attributeId);
        }
        if (!attrItem.isReference) {
            throw new Error(`${path} is not reference attribute`);
        }
        const refDictionaryId = attrItem.referencedDictionaryId;
        if (!refDictionaryId) {
            throw new Error(`No reference dictionary specified for ${path} attribute`);
        }
        const refPath = [refDictionaryId, ...rest.slice(1)].join(".");
        const refAttributePath = `${dictionaryId}.${rest[0]}`;
        const refDictionaryItemId = this.getAttributeValue(refAttributePath, itemId, lcid);
        return this.getAttributeValue(refPath, refDictionaryItemId, lcid);
    }
}
exports.DictionaryItemsStore = DictionaryItemsStore;
//# sourceMappingURL=DictionaryItemsStore.js.map